import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { API, pesanGalat } from "../lib/api";
import { useAuth } from "../auth";
import { KerangkaBaris } from "../components/kit";

const BERANDA = { admin: "/buku", pemilik: "/buku", hr: "/pamit", manajer: "/dampak" };

export default function Undangan() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [galat, setGalat] = useState(null);
  const [sandi, setSandi] = useState("");
  const [ulang, setUlang] = useState("");
  const [muat, setMuat] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    API.get(`/undangan/cek/${token}`).then((r) => setInfo(r.data)).catch((e) => setGalat(pesanGalat(e)));
  }, [token]);

  const kirim = async (e) => {
    e.preventDefault();
    if (sandi !== ulang) { setGalat("Dua kata sandinya belum sama."); return; }
    setMuat(true); setGalat(null);
    try {
      const r = await API.post("/undangan/terima", { token, password: sandi });
      localStorage.setItem("pamit_token", r.data.token);
      setUser(r.data.pengguna);
      nav(BERANDA[r.data.pengguna.peran] || "/buku");
    } catch (err) { setGalat(pesanGalat(err)); } finally { setMuat(false); }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="kaca border-b">
        <div className="max-w-[1000px] mx-auto px-4 md:px-8 h-14 flex items-center">
          <Link to="/" data-testid="tautan-beranda" className="flex items-center gap-2">
            <ShieldCheck size={18} className="text-primary" aria-hidden="true" />
            <span className="font-heading font-bold text-lg">PAM-IT</span>
          </Link>
        </div>
      </header>
      <main className="halaman-kerja flex-1 flex items-start justify-center px-4 py-16">
        <div className="panel rounded w-full max-w-md p-7">
          {!info && !galat && <KerangkaBaris testid="memuat-undangan" n={3} />}
          {!info && galat && (
            <div data-testid="galat-undangan">
              <p className="label-kecil">Undangan tidak berlaku</p>
              <h1 className="mt-3 text-2xl font-bold">{galat}</h1>
              <Link to="/masuk" className="tombol-garis inline-block mt-6 px-4 py-2 rounded text-sm">Ke halaman masuk</Link>
            </div>
          )}
          {info && (
            <>
              <p className="label-kecil">Undangan bergabung</p>
              <h1 className="mt-4 text-3xl font-bold" data-testid="judul-undangan">Halo, {info.nama}</h1>
              <p className="mt-3 text-sm text-muted-foreground">
                Anda diajak ikut menjaga catatan akses <strong className="text-foreground">{info.perusahaan}</strong>{" "}
                sebagai <strong className="text-foreground">{info.peran_label}</strong>. Buat kata sandi Anda sendiri di bawah.
              </p>
              <p className="mt-3 text-xs text-muted-foreground font-data">{info.email}</p>
              <form onSubmit={kirim} className="mt-7 space-y-4">
                <div>
                  <label htmlFor="u-sandi" className="label-kecil">Kata sandi baru (minimal 8 karakter)</label>
                  <input id="u-sandi" data-testid="input-sandi-undangan" type="password" required minLength={8}
                    value={sandi} onChange={(e) => setSandi(e.target.value)}
                    className="mt-1.5 w-full border rounded px-3 py-2.5 text-sm" />
                </div>
                <div>
                  <label htmlFor="u-ulang" className="label-kecil">Ulangi kata sandi</label>
                  <input id="u-ulang" data-testid="input-ulang-sandi" type="password" required minLength={8}
                    value={ulang} onChange={(e) => setUlang(e.target.value)}
                    className="mt-1.5 w-full border rounded px-3 py-2.5 text-sm" />
                </div>
                {galat && <p data-testid="galat-terima-undangan" className="text-sm text-destructive">{galat}</p>}
                <button data-testid="btn-terima-undangan" disabled={muat}
                  className="tombol-utama w-full px-4 py-2.5 rounded text-sm disabled:opacity-50">
                  {muat ? "Menyiapkan akun…" : "Simpan dan masuk"}
                </button>
              </form>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
